<!--
* 组件名 : 全屏诗歌播放器组件
* 开发者 : LH 重构
*
* 参数:
*  title  { String }  required - 页面标题
*  poster { String }           - 页面标题图片
*  lists  { Array }            - 诗歌列表
* 事件:  null
* 
*
-->
<template>
  <section class="v-full-screen-songs-player">
    <div class="player-box" ref="wrap">
      <div class="player-box-left">
        <lyrics ref="lyrics" />
        <controls ref="controls" />
      </div>
      <div class="player-box-right">
        <poster />
        <list ref="lists" />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

import controls from "./components/controls/index.vue";
import list from "./components/list/index.vue";
import poster from "./components/poster/index.vue";
import lyrics from "./components/lyrics/index.vue";

export default {
  name: "v-full-screen-songs-player",
  components: {
    controls,
    list,
    poster,
    lyrics,
  },
  computed: {
    ...mapGetters("global", ["apiUri"]),
    comps() {
      return {
        lyrics: this.$refs.lyrics,
        controls: this.$refs.controls,
        lists: this.$refs.lists,
      };
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    bg: {
      type: String,
      required: true,
    },
  },
  provide() {
    return {
      data: this.data,
      bg:this.bg,
      comps: () => {
        return this.comps;
      },
    };
  },
};
</script>

<style lang="scss">
@import "index";
</style>
